import profileImage from "../profile/profile.png";
import bg from "../profile/bg.jpg";
import {
    FaGithub,
    FaEnvelope,
    FaMapMarkerAlt,
    FaCode,
    FaServer,
    FaTools
} from "react-icons/fa";

const Index = () => {
    const lastUpdated = "May 18, 2025 10:00 AM";
    const qoute = "This website is under development. Please check back later for updates.";
    
    const skills = [
        { icon: <FaCode className="text-3xl" />, title: "Frontend Development", desc: "HTML, CSS, JavaScript, TypeScirpt, Next.js" },
        { icon: <FaServer className="text-3xl" />, title: "Backend Development", desc: "Supabase, MySql" },
        { icon: <FaTools className="text-3xl" />, title: "Hardware", desc: "Computer hardware troubleshooting" }
    ];

    return (
        <div
            className="min-h-screen bg-cover bg-center relative"
            style={{ backgroundImage: `url(${bg})` }}
        >
            <div className="absolute inset-0 bg-gradient-to-b from-black/60 to-black/40 z-0"></div>

            <div className="relative z-10 container mx-auto px-4 py-20">
                {/* Profile Section */}
                <div className="flex flex-col items-center text-center mb-20">
                    <div className="flex flex-wrap items-center justify-center gap-8 p-6">
                        <div className="relative custom-avatar-container group">
                            <div className="absolute inset-0 bg-gradient-to-r from-blue-500/20 to-purple-500/20 rounded-full blur-xl group-hover:blur-2xl transition-all duration-300"></div>
                            <img
                                src={profileImage}
                                alt="Profile"
                                className="custom-avatar transition-all duration-300 ease-in-out group-hover:scale-105 group-hover:translate-y-[-5px] relative z-10"
                            />
                        </div>

                        <div className="flex flex-col items-center">
                            <h1 className="text-2xl font-bold mt-2 pb-1 text-white font-sf-mono tracking-wider">
                                ᴊᴏꜱʜᴜᴀ ᴀ. ᴅᴇɢᴜɪɴᴏ
                            </h1>
                            <div className="w-48 h-[2px] bg-gradient-to-r from-transparent via-white/50 to-transparent mt-2"></div>
                            <p className="text-xl mt-2 text-white/90 font-sf-mono">
                                <span className="typing-effect">ᴡᴇʙ ᴅᴇᴠᴇʟᴏᴘᴇʀ</span>
                            </p>
                        </div>
                    </div>

                    <div className="flex items-center space-x-2 mt-6 bg-white/10 px-4 py-2 rounded-full backdrop-blur-sm">
                        <FaMapMarkerAlt className="text-lg text-white/90" />
                        <span className="text-sm text-white/90 font-sf-mono">
                            El Salvador City, Misamis Oriental, Philippines
                        </span>
                    </div>
                </div>

                {/* Main Content */}
                <div className="max-w-6xl mx-auto grid gap-10">
                    {/* About Section */}
                    <div className="backdrop-blur-md bg-white/10 rounded-2xl p-8 border border-white/20 shadow-xl hover:shadow-2xl transition-all duration-300">
                        <h2 className="tech-heading text-white mb-4">About Me</h2>
                        <p className="tech-text text-white/90 leading-relaxed text-lg">
                            A 21-year-old undergraduate student in Information Technology at USTP, passionate about full stack web development and problem-solving. Proficient in building dynamic applications using React and TypeScript, with hands-on experience in Supabase for backend services and database management. Well-versed in API integration to connect and enhance application functionalities. Also familiar with network and system administration, as well as computer hardware troubleshooting. Eager to contribute to impactful projects and continuously grow in the tech industry.
                        </p>
                    </div>

                    {/* Skills Section */}
                    <div className="grid md:grid-cols-3 gap-8">
                        {skills.map((skill, index) => (
                            <div
                                key={index}
                                className="backdrop-blur-md bg-white/10 rounded-2xl p-8 border border-white/20 shadow-xl
                                         transform hover:scale-105 transition-all duration-300 hover:shadow-2xl"
                            >
                                <div className="text-white mb-6 bg-white/10 p-4 rounded-xl inline-block">{skill.icon}</div>
                                <h3 className="tech-heading text-white mb-3">{skill.title}</h3>
                                <p className="tech-text text-white/80 text-lg">{skill.desc}</p>
                            </div>
                        ))}
                    </div>

                    {/* Social Links */}
                    <div className="flex flex-wrap justify-center gap-8 mt-12">
                        <a
                            href="https://github.com/joshuadeguino"
                            target="_blank"
                            rel="noopener noreferrer"
                            className="group flex items-center gap-3 bg-white/10 px-6 py-3 rounded-full hover:bg-white/20 transition-all duration-300"
                        >
                            <FaGithub className="text-2xl text-white/90 group-hover:text-white 
                                               transform group-hover:scale-110 transition-all duration-300" />
                            <span className="text-white/90 group-hover:text-white font-sf-mono">@joshuadeguino</span>
                        </a>
                        <a
                            href="mailto:deguino.joshua5@gmail.com"
                            target="_blank"
                            rel="noopener noreferrer"
                            className="group flex items-center gap-3 bg-white/10 px-6 py-3 rounded-full hover:bg-white/20 transition-all duration-300"
                        >
                            <FaEnvelope className="text-2xl text-white/90 group-hover:text-white 
                                                 transform group-hover:scale-110 transition-all duration-300" />
                            <span className="text-white/90 group-hover:text-white font-sf-mono">deguino.joshua5@gmail.com</span>
                        </a>
                    </div>

                    {/* Footer */}
                    <div className="text-center space-y-4 mt-16">
                        <div className="tech-label">
                            Last updated: {lastUpdated}
                        </div>
                        <div className="tech-label italic">
                            {qoute}
                        </div>
                    </div>
                </div>
            </div>

            <style jsx>{`
                .custom-avatar {
                    border-radius: 50%;
                    width: 150px;
                    height: 150px;
                    object-fit: cover;
                    border: 3px solid rgba(255, 255, 255, 0.1);
                }

                .typing-effect {
                    display: inline-block;
                    overflow: hidden;
                    white-space: nowrap;
                    border-right: 2px solid white;
                    animation: typing 6s steps(12, end) infinite;
                }

                @keyframes typing {
                    0% { width: 0; }
                    50% { width: 14ch; }
                    75% { width: 0; }
                    100% { width: 0; }
                }
            `}</style>
        </div>
    );
};

export default Index;